import React from "react";
import "./organizationAddEdit.scss";

export default function OrganizationAddEdit() {
  return (
    <div className="organization-add-edit">
      <div className="organization-add-edit-header">
        <h5>Add or Edit an Organization</h5>
      </div>
    </div>
  );
}
